// extracted by mini-css-extract-plugin
export default {"container":"i7ZuQK","list":"ZDwWRG","listItem":"zrHnUG"};